var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 p-0 d-flex align-items-center justify-content-around"},[_c('b-pagination',{staticClass:"mb-0",attrs:{"total-rows":this.pageInfo.total,"per-page":this.pageInfo.perPage,"limit":7},model:{value:(_vm.curr),callback:function ($$v) {_vm.curr=$$v},expression:"curr"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }